import React from 'react'
import { Icon } from 'semantic-ui-react'
import { AssignmentStatus } from './BatchLookupListItem'

interface Props {
  status: AssignmentStatus
}

export const BatchStatusIcon = ({ status }: Props) => {
  if (status === 'ignored') {
    return <Icon name="minus" color="grey" size="small" />
  }
  if (status === 'confirmed') {
    return <Icon name="check" color="green" size="small" />
  }
  if (status === 'selected') {
    return <Icon name="circle outline" color="grey" size="small" />
  }
  return null
}
